import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgPoyntDeviceSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.542 12.75c-.535.322-1.165.5-1.888.523l-.794 5.958a1.75 1.75 0 0 1-1.735 1.519H3.13a1.75 1.75 0 0 1-1.737-1.964l1.724-14A1.75 1.75 0 0 1 4.855 3.25H16c.081 0 .161.013.238.038l5.316 1.773a1.74 1.74 0 0 1 1.193 1.668c-.014 1.264-.099 2.948-.714 4.283-.315.684-.787 1.314-1.49 1.738Zm-2.367-7.235-1.542-.514-1.754 14.249h1.246a.25.25 0 0 0 .248-.217l1.802-13.518Zm-6.35.985H7.343a1 1 0 0 0-.99.865l-1.228 9a1 1 0 0 0 .99 1.135h4.482a1 1 0 0 0 .991-.865l1.227-9a1 1 0 0 0-.99-1.135Z",
  fill: "currentColor"
})));

export { SvgPoyntDeviceSolid as default };
